import React, { useState } from 'react';
import { MessageCircle, Phone, Shield, X } from 'lucide-react';

const HelpWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  const helpOptions = [
    {
      icon: <Phone size={20} />,
      title: 'Sofort anrufen',
      subtitle: '+49 2241 261310',
      href: 'tel:+492241261310',
      color: '#0071e3'
    },
    {
      icon: <Shield size={20} />,
      title: 'IT-Notfall?',
      subtitle: '24/7 Notdienst',
      href: 'tel:+492241261310',
      color: '#ff3b30'
    },
    {
      icon: <MessageCircle size={20} />,
      title: 'WhatsApp Chat',
      subtitle: 'Nachricht senden',
      href: 'https://wa.me/492241261310',
      color: '#25D366'
    }
  ];

  return (
    <div className="help-widget">
      {isOpen && (
        <div className="help-widget-menu">
          {helpOptions.map((option, index) => (
            <a
              key={index}
              href={option.href}
              className="help-option"
              target={option.href.startsWith('http') ? '_blank' : undefined}
              rel={option.href.startsWith('http') ? 'noopener noreferrer' : undefined}
              onClick={() => setIsOpen(false)}
            >
              <div className="help-option-icon" style={{ color: option.color }}>
                {option.icon}
              </div>
              <div className="help-option-content">
                <div className="help-option-title">{option.title}</div>
                <div className="help-option-subtitle">{option.subtitle}</div>
              </div>
            </a>
          ))}
        </div>
      )}
      
      <button
        className="help-widget-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Hilfe & Kontakt"
      >
        {isOpen ? <X size={24} /> : <MessageCircle size={24} />}
      </button>
    </div>
  );
};

export default HelpWidget;
